import { HelpContent } from "../../../Utilities/Platform/HelpManager/HelpManager";

export default class ReceiptsHelp extends HelpContent {
    public readonly title = "Receipts";
    public readonly zendeskLabel = "receipts";
    public readonly articles = {
        "Setting up Receipts": {
            zendeskId: "115003879331",
        },
        "Dynamic Fields": {
            zendeskId: "360021173732",
        },
    };
}
